import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React from 'react';
import track, { useTracking } from 'react-tracking';

var AccroPress = require("@accrosoft-ltd/accropress-node-sdk");
/**
 * Local Storage Hook
 * @param {*} localStorageKey
 */


export var useStateWithLocalStorage = function useStateWithLocalStorage(localStorageKey) {
  var _React$useState = React.useState(typeof window !== 'undefined' && localStorage.getItem(localStorageKey) || ''),
      value = _React$useState[0],
      setValue = _React$useState[1];

  React.useEffect(function () {
    if (typeof window !== 'undefined') {
      localStorage.setItem(localStorageKey, value);
    }
  }, [value]);
  return [value, setValue];
};
/**
 * Session Storage Hook
 * @param {*} sessionStorageKey
 */

export var useStateWithSessionStorage = function useStateWithSessionStorage(sessionStorageKey) {
  var _React$useState2 = React.useState(typeof window !== 'undefined' && sessionStorage.getItem(sessionStorageKey) || ''),
      value = _React$useState2[0],
      setValue = _React$useState2[1];

  React.useEffect(function () {
    if (typeof window !== 'undefined') {
      sessionStorage.setItem(sessionStorageKey, value);
    }
  }, [value]);
  return [value, setValue];
};
/**
 * Create Signals Session
 * @param {*} eventObject 
 * @param {*} collectionName 
 */

export var createSignalsSession = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(userId, sessionId, siteConfig, location, fingerprint) {
    var AccroPressSignalsAPI, AccroPressSignalsAPIAnalytics, AccroPressSignalsAPISites, sessionData, fingprintComponentsData, newSessionData;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(siteConfig && siteConfig.useSignalsAnalytics === true)) {
              _context.next = 21;
              break;
            }

            if (!(userId && sessionId && siteConfig && siteConfig.signalsSiteID)) {
              _context.next = 20;
              break;
            }

            AccroPressSignalsAPI = new AccroPress.SignalsAPIProvider({
              siteId: siteConfig.signalsSiteID,
              userId: userId,
              sessionId: sessionId
            });
            AccroPressSignalsAPIAnalytics = AccroPressSignalsAPI.analytics;
            AccroPressSignalsAPISites = AccroPress.sites;
            _context.next = 7;
            return AccroPressSignalsAPIAnalytics.getSingleSessions(sessionId);

          case 7:
            sessionData = _context.sent;

            if (!(sessionData && sessionData.sessionId)) {
              _context.next = 12;
              break;
            }

            return _context.abrupt("return", sessionData);

          case 12:
            fingerprint = fingerprint ? JSON.parse(fingerprint) : null;
            fingprintComponentsData = fingerprint && fingerprint.components ? fingerprint.components : {};
            _context.next = 16;
            return AccroPressSignalsAPIAnalytics.insertSession({
              "userId": userId,
              "sessionId": sessionId,
              "userIp": "1.1.1.1",
              "visitDate": new Date().toISOString(),
              "device": {
                availableScreenResolution: fingprintComponentsData.availableScreenResolution,
                audio: fingprintComponentsData.audio,
                colorDepth: fingprintComponentsData.colorDepth,
                cpuClass: fingprintComponentsData.cpuClass,
                deviceMemory: fingprintComponentsData.deviceMemory,
                hardwareConcurrency: fingprintComponentsData.hardwareConcurrency,
                osCpu: fingprintComponentsData.osCpu,
                platform: fingprintComponentsData.platform,
                languages: fingprintComponentsData.languages,
                timezone: fingprintComponentsData.timezone,
                timezoneOffset: fingprintComponentsData.timezoneOffset,
                touchSupport: fingprintComponentsData.touchSupport
              },
              "browser": {
                chrome: fingprintComponentsData.chrome,
                cookiesEnabled: fingprintComponentsData.cookiesEnabled,
                fonts: fingprintComponentsData.fonts,
                indexedDB: fingprintComponentsData.indexedDB,
                localStorage: fingprintComponentsData.localStorage,
                openDatabase: fingprintComponentsData.openDatabase,
                plugins: fingprintComponentsData.plugins,
                pluginSupport: fingprintComponentsData.pluginSupport,
                screenResolution: fingprintComponentsData.screenResolution,
                sessionStorage: fingprintComponentsData.sessionStorage,
                vendor: fingprintComponentsData.vendor
              },
              "location": {},
              "referer": "",
              "pages": location,
              "eventData": [{
                "eventLabel": "New Session",
                "eventAction": "initalised",
                "eventCategory": "session"
              }],
              "sessionScrap": {
                emptyEvalLength: fingprintComponentsData.emptyEvalLength,
                errorFF: fingprintComponentsData.errorFF,
                productSub: fingprintComponentsData.productSub
              }
            });

          case 16:
            newSessionData = _context.sent;
            return _context.abrupt("return", newSessionData);

          case 18:
            _context.next = 21;
            break;

          case 20:
            console.error("Params required to create a signals session were not provided");

          case 21:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function createSignalsSession(_x, _x2, _x3, _x4, _x5) {
    return _ref.apply(this, arguments);
  };
}();
/**
 * trackAnalyticsEvent
 * @param {*} eventObject
 */

export var trackAnalyticsEvent = function trackAnalyticsEvent(eventObject, userId, sessionId, siteConfig) {
  // Push events to datalayer
  window.dataLayer = window && window.dataLayer ? window.dataLayer : [];
  window.dataLayer.push(eventObject); // Push events to Signals

  _trackSignalsEvent(eventObject, userId, sessionId, siteConfig);
};
/**
 * _trackSignalsEvent
 * sends Signals tracking event
 * @param eventObject
 * @private
 */

var _trackSignalsEvent = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(eventObject, userId, sessionId, siteConfig) {
    var AccroPressSignalsAPI, AccroPressSignalsAPIAnalytics, newEventData;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!(siteConfig && siteConfig.useSignalsAnalytics === true)) {
              _context2.next = 11;
              break;
            }

            if (!(userId && sessionId && siteConfig && siteConfig.signalsSiteID)) {
              _context2.next = 10;
              break;
            }

            AccroPressSignalsAPI = new AccroPress.SignalsAPIProvider({
              siteId: siteConfig.signalsSiteID,
              userId: userId,
              sessionId: sessionId
            });
            AccroPressSignalsAPIAnalytics = AccroPressSignalsAPI.analytics;
            _context2.next = 6;
            return AccroPressSignalsAPIAnalytics.addSessionEvent(sessionId, eventObject);

          case 6:
            newEventData = _context2.sent;
            return _context2.abrupt("return", newEventData);

          case 10:
            console.error("Params required to track an event were not provided");

          case 11:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function _trackSignalsEvent(_x6, _x7, _x8, _x9) {
    return _ref2.apply(this, arguments);
  };
}();
/**
 * trackAnalyticsPageView
 * @param {*} eventObject
 */


export var trackAnalyticsPageView = function trackAnalyticsPageView(location, userId, sessionId, siteConfig) {
  if (siteConfig && siteConfig.useSignalsAnalytics === true) {
    if (location && userId && sessionId && siteConfig && siteConfig.signalsSiteID) {
      // Push events to Signals
      _trackSignalsPageView(location, userId, sessionId, siteConfig);
    } else {
      console.error("Params required to track an event were not provided");
    }
  }
};
/**
 * _trackSignalsPageView
 * sends Signals tracking event
 * @param eventObject
 * @private
 */

var _trackSignalsPageView = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(eventObject, userId, sessionId, siteConfig) {
    var AccroPressSignalsAPI, AccroPressSignalsAPIAnalytics, newEventData;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (!(siteConfig && siteConfig.useSignalsAnalytics === true)) {
              _context3.next = 14;
              break;
            }

            if (!(eventObject && userId && sessionId && siteConfig && siteConfig.signalsSiteID)) {
              _context3.next = 13;
              break;
            }

            AccroPressSignalsAPI = new AccroPress.SignalsAPIProvider({
              siteId: siteConfig.signalsSiteID,
              userId: userId,
              sessionId: sessionId
            });
            AccroPressSignalsAPIAnalytics = AccroPressSignalsAPI.analytics;
            eventObject.timeOn = 1;
            eventObject.url = eventObject.href;
            eventObject.name = eventObject.pathname;
            _context3.next = 9;
            return AccroPressSignalsAPIAnalytics.addSessionPages(sessionId, eventObject);

          case 9:
            newEventData = _context3.sent;
            return _context3.abrupt("return", newEventData);

          case 13:
            console.error("Params required to track an event were not provided");

          case 14:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function _trackSignalsPageView(_x10, _x11, _x12, _x13) {
    return _ref3.apply(this, arguments);
  };
}();